{
  "page_count": "sur {n, plural, one{# page} other{# pages}}"
}
